export const Step = {
  SelectEmployer: 'selectEmployer',
  Upload: 'upload',
  Review: 'review',
  Submitting: 'submitting',
} as const;

export type Step = (typeof Step)[keyof typeof Step];
